export default __webpack_public_path__ + "static/media/killswitchreport.3e71c4ef.jpg";